import React from 'react';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Button } from 'components/form/Button/Button';
import { Image } from 'components/Image/Image';
import { Row } from 'components/Containers/Row/Row';
import './PersonalLoanLowScoreModuleView.scss';
import Label from 'components/form/Label/Label';
import { BulletList, Bullet } from 'components/BulletList';
import OText from 'components/CText/OText';

const bullets = [
  'See instantly if you’re pre-qualified',
  'Get funds in as little as one day',
  'Low credit scores accepted',
];
const PersonalLoanLowScoreModuleView = props => {
  return (
    <SectionContainer className={'personalLoanLowScoreContainer'}>
      <Row>
        <FlexContainer className={'justify-between'}>
          <FlexContainer className={'infoContainer flex-column'}>
            <Label typeHeader={'h3'} className="H3 mH5">
              {'Have an emergency expense? Get it covered with a personal loan'}
            </Label>
            <BulletList className="m-lineHeight-1-4 margT12">
              {bullets.map((item, index) => {
                return (
                  <Bullet className="text-16 margT4 block">
                    <OText text={item} />
                  </Bullet>
                );
              })}
            </BulletList>

            <FlexContainer className={'flex-column prequalButton'}>
              <FlexContainer className={'m-justify-center m-margTB24 d-hide'}>
                <Image imgClass={'personalLoanImage bgImageW263 bgImageH157'} />
              </FlexContainer>
              <Button
                mrphType="primary"
                onClick={props.onClickPrequal}
                className="border-rad4px"
              >
                <Label type="Subtitle-2" color="primary_cta_text_light">
                  {'See If I’m Pre-Qualified'}
                </Label>
              </Button>
              <Label type="Body-2" className={'text-center margT8'}>
                {'No impact to your credit score'}
              </Label>
            </FlexContainer>
          </FlexContainer>
          <FlexContainer className={'align-items-center m-hide'}>
            <Image imgClass={'personalLoanImage bgImageW263 bgImageH157'} />
          </FlexContainer>
        </FlexContainer>
      </Row>
    </SectionContainer>
  );
};

export default PersonalLoanLowScoreModuleView;
